const hamburger = document.getElementById("menuButton");
const mobileMenu = document.getElementById("mobileNav");
const mobileMenuHeight = mobileMenu?.firstElementChild?.clientHeight;
const closeIcon = document.getElementById("closeIcon");
const menuOverlay = document.getElementById("menuOverlay");

if (hamburger && mobileMenu && mobileMenuHeight && closeIcon && menuOverlay) {
  //Close icon
  closeIcon.addEventListener("click", (e) => {
    mobileMenu.style.left = "-290px";
    hamburger.classList.remove("active");
    menuOverlay.classList.remove("active")
  });

  //Hamburger icon
  hamburger.addEventListener("click", (e) => {

      mobileMenu.style.left = "0px";
      menuOverlay.classList.add("active")

  });
}
